export default {
  formSubmitHost: 'http://contact.apps-api.instantpage.dev-secureserver.net:8400',
  // Use this one to directly call the DEV API
  // formSubmitHost: 'http://contact.apps-api.instantpage.dev-secureserver.net',
  generateUrlHost: 'http://url-generator.apps.dev-secureserver.net:8080',
  contactsHost: 'https://contacts.dev-godaddy.com',
  conversationsWebHost: 'https://local.gasket.dev-godaddy.com:8448'
};
